import React, { useState } from "react";
import "./NavBar.css";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Dropdown, Menu, Tooltip, Tabs, Button } from "antd";
import {
  HomeOutlined,
  MenuOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
const { TabPane } = Tabs;

// const BLOB_PDF_URL =
//   "https://ztostctl1.blob.core.windows.net/caeeto/ETO%20User%20Guide%20for%20Originator.pdf?sv=2023-01-03&st=2025-03-27T14%3A21%3A00Z&se=2100-12-31T15%3A21%3A00Z&sr=b&sp=r&sig=wl5aJtv%2B%2BVT%2Bl124IiNaSA5FoXBhb3w%2FFOEycmN4Qsg%3D&rscd=inline%3B%20filename%3D%22OriginatorGuide.pdf%22&rsct=application%2Fpdf";

function NavBar({ onLogout }) {
  const userRole = localStorage.getItem("userRole");
  const userName = localStorage.getItem("userName");
  const [isGuideVisible, setIsGuideVisible] = useState(false);

  const showGuide = () => setIsGuideVisible(true);
  const closeGuide = () => setIsGuideVisible(false);

  function getInitials(name) {
    const names = name.split(" ");
    const initials = names.map((part) => part[0]).join("");
    return initials;
  }
  const userInitials = userName ? getInitials(userName) : "";
  const navigate = useNavigate();
  const job = {};
  const handleFlowchartNavigation = () => {
    job["from"] = "NavBar";
    navigate("/flowchart", { state: job });
  };

  function getRoleColor(role) {
    switch (role) {
      case "Admin":
        return "#8a62bd";
      case "Project Leader":
        return "#707fd4";
      case "Engineer":
        return "#E63946";
      case "Cost Center Manager":
        return "#F4A261";
      case "Test Technician":
        return "#2A9D8F";
      default:
        return "#CCCCCC";
    }
  }
  const roleColor = getRoleColor(userRole);

  const menu = (
    <Menu>
      <Menu.Item>
        <Link to="/profile">Profile</Link>
      </Menu.Item>
      {(userRole === "Engineer" || userRole === "Admin") && (
        <Menu.Item>
          <Link to="/addJob">Add Job</Link>
        </Menu.Item>
      )}
      <Menu.Item onClick={handleFlowchartNavigation}>
        Flowchart Editor Mode
      </Menu.Item>
      {userRole === "Admin" && (
        <>
          <Menu.Item>
            <Link to="/users">Manage Users</Link>
          </Menu.Item>
          <Menu.Item>
            <Link to="/adminPanel">Admin Panel</Link>
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  // return (
  //   <nav>
  //     <div className="logo">
  //       <Link to="/">
  //         <img src="magna-logo.png" alt="Logo" />
  //       </Link>
  //       {userName}
  //       <ul className="nav-link">
  //         <li className="li-link">
  //           <Link to="/"><HomeOutlined /></Link>
  //         </li>
  //         <li className="li-link">
  //           <Dropdown overlay={menu} trigger={['click']}>
  //             <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
  //               <MenuOutlined />
  //             </a>
  //           </Dropdown>
  //         </li>
  //       </ul>
  //     </div>

  //     <ul className="nav-links">
  //       <li>
  //         <button onClick={onLogout} className="logout-button">
  //           Logout
  //         </button>
  //       </li>
  //     </ul>
  //   </nav>
  // );

  return (
    <>
      <nav>
        <div className="logo">
          <Link to="/">
            {/* <img src="eto-logo.png" alt="Logo" /> */}
            <img src="new.png" alt="Logo" />
          </Link>
          <ul className="nav-link"></ul>
          <small style={{ marginTop: "20px", marginLeft: "10px" }}>V1.4</small>
        </div>

        <ul className="nav-links">
          <li className="li-link">
            <Tooltip title="Home">
              <Link to="/">
                <HomeOutlined className="icon-hover" />
              </Link>
            </Tooltip>
          </li>

          <li className="li-link">
            <Tooltip title="User Guide">
              <QuestionCircleOutlined
                style={{ fontSize: "18px", cursor: "pointer" }}
                onClick={showGuide}
                className="icon-hover"
              />
            </Tooltip>
          </li>

          <li className="li-link">
            <Tooltip title="Options Menu">
              <Dropdown overlay={menu} trigger={["click"]}>
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                  style={{ cursor: "pointer" }}
                >
                  <MenuOutlined className="icon-hover" />
                </a>
              </Dropdown>
            </Tooltip>
          </li>

          <Tooltip title="Profile">
            <Link to="/profile" className="profile-link">
              <span
                className="user-initials"
                style={{ borderColor: roleColor }}
              >
                {userInitials}
              </span>
            </Link>
          </Tooltip>

          <li>
            <Tooltip title="Logout">
              <button onClick={onLogout} className="logout-button">
                Logout
              </button>
            </Tooltip>
          </li>
        </ul>
      </nav>

      <Modal
        title="User Guide"
        visible={isGuideVisible}
        onCancel={closeGuide}
        footer={null}
        width={800}
      >
        <Tabs defaultActiveKey="originator">
          <TabPane tab="Originator" key="originator">
            <iframe
              title="Originator Guide"
              src="/guides/OriginatorGuide.pdf"
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />

            <div style={{ marginTop: "16px", textAlign: "right" }}>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                href="/guides/OriginatorGuide.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download="OriginatorGuide.pdf"
              >
                Download Guide
              </Button>
            </div>
          </TabPane>
        </Tabs>
      </Modal>
    </>
  );
}

export default NavBar;
